import { render, staticRenderFns } from "./user.vue?vue&type=template&id=077f47b0"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('077f47b0')) {
      api.createRecord('077f47b0', component.options)
    } else {
      api.reload('077f47b0', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=077f47b0", function () {
      api.rerender('077f47b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/user.vue"
export default component.exports